import type { ReactNode } from 'react';

import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
export interface MenuItem {
  link?: string;
  icon?: ReactNode | React.ElementType;
  badge?: string;
  badgeTooltip?: string;

  items?: MenuItem[];
  name: string;
  permission?: string[];
  ressource?: string[];
  action?: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
  permission?: string[];
}

const menuItems: MenuItems[] = [
  {
    heading: 'Activity',
    items: [
      {
        name: 'Dashboard',
        link: '/',
        icon: SpaceDashboardOutlinedIcon,
      },
      {
        name: 'Crypto payments',
        icon: SwapHorizOutlinedIcon,
        link: '',
        ressource: ['cryptoOrders', 'cryptoConversions', 'paymentLinks'],
        action: 'list',
        items: [
          {
            name: 'Transactions',
            link: '/cryptoOrders',
            ressource: ['cryptoOrders'],
            action: 'list',
          },
          {
            name: 'Conversions',
            link: '/cryptoConversions',
            ressource: ['cryptoConversions'],
            action: 'list',
          },
          {
            name: 'Payment links',
            link: '/paymentLinks',
            ressource: ['paymentLinks'],
            action: 'list',
          }
        ]
      },
      {
        name: 'Gas station',
        icon: LocalGasStationOutlinedIcon,
        link: '',
        ressource: ['gasStationTransfers', 'gasStationStatements'],
        action: 'list',
        items: [
          {
            name: 'Transfers',
            link: '/gasStationTransfers',
            ressource: ['gasStationTransfers'],
            action: 'list',
          },
          {
            name: 'Statements',
            link: '/gasStationStatements',
            ressource: ['gasStationStatements'],
            action: 'list',
          }
        ]
      }
    ]
  },
  {
    heading: 'Settings',
    items: [
      {
        name: 'Administration',
        icon: ManageAccountsOutlinedIcon,
        link: '',
        ressource: ['users', 'projects', "accounts"],
        action: 'edit',
        items: [
          {
            name: 'Users',
            link: '/users',
            ressource: ['users'],
            action: 'edit',
          },
          {
            name: 'Entities',
            link: '/projects',
            ressource: ['projects'],
            action: 'edit',
          },
          {
            name: 'Accounts',
            link: '/accounts',
            ressource: ['accounts'],
            action: 'edit',
          }
        ]
      }
    ]
  }
];

export default menuItems;
